.flow {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.flowTitle {
  font-size: 15px;
  font-weight: 600;
}

.muted {
  color: var(--text-muted);
  font-size: var(--font-size-sm);
}

.good {
  color: var(--success);
  font-size: var(--font-size-sm);
}

.bad,
.errorText {
  color: var(--danger);
  font-size: var(--font-size-sm);
}

.warning {
  margin: 0;
  color: var(--warning-strong);
  font-size: var(--font-size-sm);
}

.points {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding-left: 18px;
  color: var(--text-muted);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* ---- server address ---- */
.serverField {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.serverRow {
  display: flex;
  gap: 8px;
}

.serverRow input,
.passphraseInput {
  height: var(--control-h);
  min-width: 0;
  flex: 1;
  padding: 0 10px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-sm);
  background: var(--surface);
}

.serverRow input[aria-invalid='true'],
.passphraseInput[aria-invalid='true'] {
  border-color: var(--danger);
}

.healthLine {
  min-height: 18px;
  margin: 0;
}

/* ---- generated passphrase ---- */
.words {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.words li {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--surface-muted);
  font-family: ui-monospace, 'SFMono-Regular', Menlo, Consolas, monospace;
  font-size: 15px;
}

.wordNumber {
  min-width: 1.5em;
  color: var(--text-muted);
  font-size: var(--font-size-sm);
  text-align: right;
}

.spaceLine {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-sm);
  font-family: ui-monospace, 'SFMono-Regular', Menlo, Consolas, monospace;
}

.warning {
  text-wrap: balance;
  padding: 10px 12px;
  border-radius: var(--radius-sm);
  background: color-mix(in srgb, var(--danger) 8%, var(--surface));
  color: var(--danger);
}

.checkRow {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.checkRow input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--accent);
}

.progress {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--text-muted);
}

.progress progress {
  width: 140px;
  height: 8px;
  accent-color: var(--accent);
}

/* ---- join ---- */
.passphraseInput {
  height: auto;
  padding: 8px 10px;
  font-family: ui-monospace, 'SFMono-Regular', Menlo, Consolas, monospace;
  resize: vertical;
  line-height: 1.5;
}

.notice {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 10px 12px;
  border-radius: var(--radius-sm);
  background: color-mix(in srgb, var(--warning) 12%, var(--surface));
}

/* ---- enabled ---- */
.statusRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.facts {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: 6px 16px;
  margin: 0;
}

.facts dt {
  color: var(--text-muted);
}

.facts dd {
  margin: 0;
  overflow-wrap: anywhere;
}

@media (max-width: 767px) {
  .words {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* ---- account forms ---- */
.fieldset {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 14px;
  margin: 0;
  padding: 0;
  border: 0;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field input:not([type='checkbox']) {
  height: var(--control-h);
  min-width: 0;
  padding: 0 10px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-sm);
  background: var(--surface);
}

.field input[aria-invalid='true'],
.field textarea[aria-invalid='true'] {
  border-color: var(--danger);
}

.field p {
  margin: 0;
}

.fieldRow {
  display: flex;
  gap: 8px;
}

/* Only next to the show/hide button does the input stretch to fill the row; a column child of
   .field would have flex-basis 0% override the height set above. */
.fieldRow input {
  flex: 1;
}

.failureRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.failureRow p {
  margin: 0;
}

.divider {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 14px;
  border-top: 1px solid var(--border);
}

.dividerTitle {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--text-muted);
}

.linkButton {
  align-self: flex-start;
  padding: 0;
  border: 0;
  background: none;
  color: var(--accent);
  cursor: pointer;
  text-decoration: underline;
}

.sessionList {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.sessionRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
}

.sessionText {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.currentTag {
  margin-left: 8px;
  padding: 1px 6px;
  border-radius: var(--radius-sm);
  background: color-mix(in srgb, var(--success) 14%, var(--surface));
  color: var(--success);
  font-size: var(--font-size-sm);
  font-weight: normal;
}

.localStatus {
  margin: 0;
  font-weight: 600;
}
